<div *ngIf="tabs?.length > 0" class="mui-tabs__navigation" role="tablist">
  <div
    *ngFor="let tab of tabs; let i = index"
    class="mui-tabs__navigation-item"
    [class.active]="currentTab === tab"
    [id]="tab.uid"
    role="tab"
    [attr.tabindex]="currentTab === tab ? '-1' : '0'"
    [attr.aria-posinset]="i + 1"
    [attr.aria-setsize]="tabs.length"
    [attr.aria-controls]="tab.uid + '-panel'"
    [attr.aria-label]="tab.label"
    [attr.aria-selected]="currentTab === tab"
    (keydown.enter)="setActiveTab(tab)"
    (click)="setActiveTab(tab)">
    <span class="mui-tabs__navigation-item__link">
      <i *ngIf="tab.icon" mui-icon [name]="tab.icon" [font]="tab.iconFont" class="mui-tabs__navigation-item__icon"></i>
      <span class="mui-tabs__navigation-item__label">{{ tab.label }}</span>
    </span>
  </div>
</div>
<div
  *ngFor="let tab of tabs"
  class="mui-tabs__tab"
  role="tabpanel"
  [id]="tab.uid + '-panel'"
  [class.mui-tabs__tab--active]="currentTab === tab"
  [attr.aria-hidden]="currentTab !== tab"
  [attr.aria-labelledby]="tab.uid"
  [@tab]="currentTab?.uid">
  <ng-container *ngIf="currentTab === tab">
    <ng-container [ngTemplateOutlet]="tab.template"></ng-container>
  </ng-container>
</div>
